var cachedResult;
export function doesSupportTouchActionNone() {
  if (cachedResult === undefined) {
    var element = document.createElement('div');
    element.style.touchAction = 'none';
    document.body.appendChild(element);
    cachedResult = window.getComputedStyle(element).touchAction === 'none';
    element.parentElement.removeChild(element);
  }
  return cachedResult;
}